import {
  ACTIVE_DESIGN_SYSTEM_VERSION,
  getDesignSystem,
} from '../../../../../../../layouts/theme/designSystem';
import type {DesignSystemVersion} from '../../../../../../../layouts/theme/designSystem';

export type SurveyStatisticBarTokens = {
  track: string;
  trackMuted: string;
  fill: string;
  gender: {
    masculine: string;
    feminine: string;
    diverse: string;
    preferNotToSay: string;
  };
  language: string;
};

const buildSurveyStatisticBars20260615 = (version: DesignSystemVersion): SurveyStatisticBarTokens => {
  const {greenColors, orangeColors} = getDesignSystem(version);

  return {
    track: orangeColors[7],
    trackMuted: orangeColors[3],
    fill: greenColors[100],
    gender: {
      masculine: '#5D7A9E',
      feminine: '#B07A8C',
      diverse: greenColors[70],
      preferNotToSay: orangeColors[70],
    },
    language: '#3266AD',
  };
};

const buildSurveyStatisticBars20260616 = (): SurveyStatisticBarTokens => {
  const {greenColors, orangeColors} = getDesignSystem('20260616');

  return {
    track: orangeColors[7],
    trackMuted: orangeColors[3],
    fill: greenColors[100],
    gender: {
      masculine: greenColors[40],
      feminine: orangeColors[40],
      diverse: greenColors[70],
      preferNotToSay: orangeColors[70],
    },
    language: greenColors[500],
  };
};

const buildSurveyStatisticBarsMonochrome = (): SurveyStatisticBarTokens => {
  const {greenColors, orangeColors} = getDesignSystem('monochrome');

  return {
    track: orangeColors[7],
    trackMuted: orangeColors[3],
    fill: greenColors[100],
    gender: {
      masculine: '#505050',
      feminine: '#707070',
      diverse: '#909090',
      preferNotToSay: '#b0b0b0',
    },
    language: greenColors[500],
  };
};

export const getSurveyStatisticBarTokens = (
  version: DesignSystemVersion = ACTIVE_DESIGN_SYSTEM_VERSION,
): SurveyStatisticBarTokens => {
  if (version === '20260616') {
    return buildSurveyStatisticBars20260616();
  }

  if (version === 'monochrome') {
    return buildSurveyStatisticBarsMonochrome();
  }

  return buildSurveyStatisticBars20260615(version);
};

export const surveyStatisticBars = getSurveyStatisticBarTokens();
